import React, { useState } from 'react';
import Form from '../../Modules/form/components/Form';
import { Card, CardBody, FormGroup, Label, Row, Col } from 'reactstrap';
import Box from '@material-ui/core/Box'

import AgencyMultiselect from '../../Modules/form/components/specialized/AgencyMultiSelect';
import DateInput from '../../Modules/form/components/DateInput';

import { exportDataRequest } from './hooks';
import LoadingButton from '../Helpers/LoadingButton';

const FORM_KEY = 'holidaycare-export';
const EXPORT_TYPE = 'holidaycare';

const FeiertagsbetreuungExport = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleExportSubmit = async (values) => {
        try {
            setLoading(true);
            await exportDataRequest(EXPORT_TYPE, values);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box mt={3}>
            <Card data-cy="card-holidaycare">
                <h6 className="card-header">Export Feiertagsbetreuung</h6>
                <CardBody>
                    <p>
                        Unter folgendem Link kann die Datei für die Feiertagsbetreuung heruntergeladen
                        werden.
                    </p>
                    <Form onSubmit={handleExportSubmit}>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <DateInput
                                        label="Zeitraum vom:"
                                        name="date_from"
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <DateInput
                                        label="bis:"
                                        name="date_till"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Agentur:</Label>
                                    <AgencyMultiselect
                                        name="agency"
                                        label="Agentur"
                                        fullWidth
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="text-center">
                            <LoadingButton
                                color="primary"
                                id={FORM_KEY}
                                title="Klicken um die Datei herunterzuladen"
                                type="submit"
                                isLoading={loading}
                            >
                                Herunterladen
                            </LoadingButton>
                        </div>
                        {error && <div className="text-danger">{error.message}</div>}
                    </Form>
                </CardBody>
            </Card>
        </Box>
    );
};

FeiertagsbetreuungExport.propTypes = {

};

FeiertagsbetreuungExport.defaultProps = {

};

export default FeiertagsbetreuungExport;
